"use client";
import { useState } from "react";
const faqs = [
    {
        question: "Can kidney disease be cured?",
        answer: "Early-stage kidney disease can often be controlled with proper treatment and lifestyle changes. Severe cases may require dialysis or a transplant.",
    },
    {
        question: "How often should kidney function be checked?",
        answer: "People with diabetes, hypertension, or family history of kidney disease should test at least once a year.",
    },
    {
        question: "Is dialysis painful?",
        answer: "Dialysis isn’t painful. Patients may feel mild discomfort initially, but most adjust quickly with proper care.",
    },
    {
        question: "What foods should kidney patients avoid?",
        answer: "Limit salt, processed foods, red meat, and high-phosphorus items. Our dieticians will provide personalised plans.",
    },
    {
        question: "Where is the best kidney care available in Patna?",
        answer: "HDNA Aarogyam Hospital offers one of the most comprehensive nephrology and renal care facilities in Patna with 24x7 expert support.",
    },
    {
        question: "When should I consult a nephrologist?",
        answer: "You should see a nephrologist if you experience swelling, reduced urine output, persistent fatigue, uncontrolled blood pressure, or abnormal kidney test results.",
    },
    {
        question: "What types of dialysis are available at HDNA Aarogyam Hospital?",
        answer: "HDNA Aarogyam Hospital provides both haemodialysis and peritoneal dialysis under strict safety and infection-control protocols.",
    },
    {
        question: "Does HDNA Aarogyam Hospital offer kidney transplant services?",
        answer: "Yes, our Institute of Renal Science & Renal Transplant provides complete kidney transplant care, including pre-transplant evaluation, surgery, and post-transplant follow-up.",
    },
    {
        question: "Can kidney disease be managed without dialysis?",
        answer: "Yes, many kidney conditions can be managed with medication, diet, and lifestyle changes, especially when diagnosed early.",
    },
    {
        question: "Is long-term follow-up required for kidney patients?",
        answer: "Yes, regular follow-ups are essential to monitor kidney function, prevent complications, and maintain long-term kidney health.",
    }
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
